import * as mmsList from '../services/mmsList';

export default {
  namespace: 'mmsList',

  state: {
    // userInfo: null,
    // getMemberList: null,
    // addMember: null,
  },

  effects: {
    *getMmsList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(mmsList.getMmsList, values);
      yield put({
        type: 'save',
        payload: {
          mmsList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *deleteTempMsg({ payload: { values }, callback }, { call }) {
      const response = yield call(mmsList.deleteTempMsg, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    // *addMember({ payload: { values }, callback }, { call, put }) {
    //   const response = yield call(cpList.addMember, values);
    //   if (response) {
    //     if (callback && typeof callback === 'function') {
    //       return callback(response);
    //     }
    //   }
    //   yield put({
    //     type: 'save',
    //     payload: {
    //       addMember: response,
    //     },
    //   });
    // },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
